import { isFunction } from './assertion.esm.js';

var noop = function noop() {};
function callAllHandlers() {
  for (var _len5 = arguments.length, fns = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    fns[_key5] = arguments[_key5];
  }

  return function (event) {
    fns.some(function (fn) {
      if (fn) {
        fn(event);
      }

      return event && event.defaultPrevented;
    });
  };
}
var wrapEvent = function wrapEvent(externalHandler, internalHandler) {
  return function (event) {
    if (externalHandler) {
      externalHandler(event);
    }

    if (!event.defaultPrevented && internalHandler) {
      return internalHandler(event);
    }

    return undefined;
  };
};
function runIfFn(valueOrFn) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    args[_key6 - 1] = arguments[_key6];
  }

  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}

export { callAllHandlers, noop, runIfFn, wrapEvent };
//# sourceMappingURL=function.esm.js.map
